import types from './searchTypes';
import { takeLatest, all } from "redux-saga/effects";
import * as actions from './searchActions';

export default function* searchGetPostmortemsSagas() {
  yield all([
    yield takeLatest(types.SEARCH_GET_POSTMORTEMS_REQUEST, actions.searchGetPostmortems),
  ]);
}
